<div class="wrapper">
  <div id="currentChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #currentChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>Current graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="50"></mat-progress-spinner>
    </div>
  }
</div>